/**
 * companySettingsSlice — single source of truth for the Company Settings form.
 *
 * Hydrated from the SSR fetch via CompanySettingsInitializer; the form seeds
 * its editable fields from here and dispatches `setCompanySettings` /
 * `setCompanyLogo` after a successful save so the store stays in sync.
 */
import { createSlice, type PayloadAction } from "@reduxjs/toolkit";
import type { CompanySettings } from "@/actions/ssr/settings/getCompanySettingsSSR";

export interface CompanySettingsState {
  company: CompanySettings | null;
  loading: boolean;
}

const initialState: CompanySettingsState = {
  company: null,
  loading: true,
};

const companySettingsSlice = createSlice({
  name: "companySettings",
  initialState,
  reducers: {
    /** Replace the company profile — used to hydrate from the API on mount. */
    setCompanySettings(state, action: PayloadAction<CompanySettings | null>) {
      state.company = action.payload;
    },
    /** Update only the logo URL (after a successful logo upload). */
    setCompanyLogo(state, action: PayloadAction<string>) {
      if (state.company) state.company.logo_url = action.payload;
    },
    setCompanyLoading(state, action: PayloadAction<boolean>) {
      state.loading = action.payload;
    },
  },
});

export const { setCompanySettings, setCompanyLogo, setCompanyLoading } =
  companySettingsSlice.actions;

export default companySettingsSlice.reducer;
